// src/pages/Processamentos.jsx
import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import Loading from '../components/Loading';
import ErrorToast from '../components/ErrorToast';
import Paginacao from '../components/Paginacao';
import ProcessamentoCard from '../components/ProcessamentoCard';
import './Processamentos.css';

const Processamentos = () => {
  const [processos, setProcessos] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(12); // Ajustado para um layout de grid
  const [totalItens, setTotalItens] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchProcessos = useCallback(async (p = 1) => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get(`/processamentos`, {
        params: { page: p, pageSize }
      });
      setProcessos(res.data.data);
      setTotalItens(res.data.total);
      setPage(p);
    } catch {
      setError('Erro ao listar processamentos.');
    } finally {
      setLoading(false);
    }
  }, [pageSize]);

  useEffect(() => {
    fetchProcessos(page);
  }, [fetchProcessos, page]);

  return (
    <div className="processamentos-container">
      <h1>Processamentos</h1>
      {error && <ErrorToast message={error} onClose={() => setError('')} />}
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="processamentos-grid">
            {processos.map(proc => (
              <ProcessamentoCard key={proc.id} processo={proc} />
            ))}
          </div>
          <Paginacao
            totalItens={totalItens}
            itensPorPagina={pageSize}
            paginaAtual={page}
            setPaginaAtual={setPage}
          />
        </>
      )}
    </div>
  );
};

export default Processamentos;
